<template>
  <div class="designations">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Salary Category</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item active">Salary</li>
                </ul>
              </div>
              <div class="col-auto float-right ml-auto">
                <a @click="openDialog" class="btn add-btn">
                  <i class="fa fa-plus"></i> Add Sub Category
                </a>
              </div>
            </div>
          </div>
          <!-- /Page Header -->
          <!----Datatable-->
          <div class="row">
            <div class="col-md-12">
              <div
                class="alert alert-danger alert-dismissible fade show"
                role="alert"
                v-if="error"
              >
                <strong>Error!</strong> {{ error }}
                <button
                  type="button"
                  class="close"
                  data-dismiss="alert"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            </div>
            <div class="col-md-12">
              <div class="table-responsive">
                <v-data-table
                  :headers="headers"
                  :items="subs"
                  sort-by="name"
                  class="elevation-1"
                >
                  <template v-slot:[`item.actions`]="{ item }">
                    <div class="dropdown dropdown-action" v-if="item.companyId">
                      <a
                        href="#"
                        class="action-icon dropdown-toggle"
                        data-toggle="dropdown"
                        aria-expanded="false"
                        ><i class="material-icons">more_vert</i></a
                      >
                      <div class="dropdown-menu dropdown-menu-right">
                        <a class="dropdown-item" @click="setEdit(item)"
                          ><i class="fa fa-pencil m-r-5"></i> Edit</a
                        >
                        <a class="dropdown-item" @click="setDelete(item)"
                          ><i class="fa fa-trash-o m-r-5"></i> Delete</a
                        >
                      </div>
                    </div>
                  </template>
                </v-data-table>
                <!-- <template v-slot:[`item.profile`]="{ item }">
        <h2 class="table-avatar blue-link">
                          <router-link to="/profile" class="avatar"
                            ><img alt="" src="../assets/profiles/avatar-02.jpg"
                          /></router-link>
                          <router-link to="/profile">{{
                            `${item.firstName}`
                          }}</router-link>
                        </h2>
      </template> -->

                <!-- <table class="table table-striped custom-table mb-0 datatable">
                  <thead>
                    <tr>
                      <th style="width: 30px;">#</th>
                      <th>Designation </th>
                      <th>Department </th>
                      <th class="text-right">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in designations" v-bind:key="item.id">
                      <td>{{index + 1}}</td>
                      <td>{{item.name}}</td>
                      <td>{{item.department.name}}</td>
                      <td class="text-right">
                        <div class="dropdown dropdown-action">
                          <a href="#" class="action-icon dropdown-toggle" data-toggle="dropdown"
                            aria-expanded="false"><i class="material-icons">more_vert</i></a>
                          <div class="dropdown-menu dropdown-menu-right">
                            <a class="dropdown-item" @click="setEditDesignation(item)" data-toggle="modal" data-target="#edit_designation"><i
                                class="fa fa-pencil m-r-5"></i> Edit</a>
                            <a class="dropdown-item" @click="setDesignation(item)" data-toggle="modal" data-target="#delete_designation"><i
                                class="fa fa-trash-o m-r-5"></i> Delete</a>
                          </div>
                        </div>
                      </td>
                    </tr>

                    
                    
                    
                   
                   
                    
                  </tbody>
                </table> -->
              </div>
            </div>
          </div>
          <!---/Datatable-->
        </div>
        <!-- /Page Content -->
        <!-- Add Designation Modal -->
        <v-dialog v-model="dialog" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Add Sub Category</h5>
              <button type="button" class="close" @click="close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form @submit.prevent="onSubmit">
                <div class="form-group">
                  <label> Name <span class="text-danger">*</span></label>
                  <input
                    type="text"
                    v-model.trim="$v.name.$model"
                    id="name"
                    name="name"
                    class="form-control"
                    :class="{ 'is-invalid': submitted && $v.name.$error }"
                  />
                  <div
                    v-if="submitted && !$v.name.required"
                    class="invalid-feedback"
                  >
                    Name is required
                  </div>
                  <!-- <input class="form-control" type="text"> -->
                </div>
                <div class="form-group">
                  <label>Category <span class="text-danger">*</span></label>
                  <select
                    id="category"
                    name="category"
                    class="form-control"
                    v-model.trim="$v.category.$model"
                    :class="{ 'is-invalid': submitted && $v.category.$error }"
                  >
                    <option disabled>Select Category</option>
                    <option
                      v-for="item in categories"
                      :key="item.id"
                      :value="item.id"
                    >
                      {{ item.name }}
                    </option>
                  </select>
                  <div
                    v-if="submitted && !$v.category.required"
                    class="invalid-feedback"
                  >
                    Category is required
                  </div>
                </div>
                <div class="submit-section">
                  <button
                    @click.prevent="onSubmit"
                    class="btn btn-primary submit-btn"
                    data-dismiss="modal"
                    :disabled="submitted"
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </v-dialog>
        <!-- /Add Designation Modal -->
        <!-- Edit Designation Modal -->
        <v-dialog v-model="dialogEdit" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Edit Sub Category</h5>
              <button type="button" class="close" @click="closeEdit">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form>
                <div class="form-group">
                  <label> Name <span class="text-danger">*</span></label>
                  <input
                    type="text"
                    v-model="sub.name"
                    id="name"
                    name="name"
                    class="form-control"
                  />
                  <!-- <input class="form-control" type="text" v-model="departmentName" > -->
                </div>

                <div class="form-group">
                  <label>Category <span class="text-danger">*</span></label>
                  <select
                    id="category"
                    name="category"
                    class="form-control"
                    v-model="category"
                  >
                    <option disabled>Select Category</option>
                    <option
                      v-for="item in categories"
                      :key="item.id"
                      :value="item.id"
                    >
                      {{ item.name }}
                    </option>
                  </select>
                </div>
                <div class="submit-section">
                  <button
                    @click.prevent="updateSub"
                    class="btn btn-primary submit-btn"
                    data-dismiss="modal"
                  >
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        </v-dialog>
        <!-- /Edit Designation Modal -->
        <!-- Delete Designation Modal -->
        <v-dialog v-model="dialogDelete" max-width="725px">
          <div class="modal-content">
            <div class="modal-body">
              <div class="form-header">
                <button type="button" class="closeDelete" @click="close">
                  <span aria-hidden="true">&times;</span>
                </button>
                <h3>Delete Sub Category</h3>
                <p>Are you sure want to delete?</p>
              </div>
              <div class="modal-btn delete-action">
                <div class="row">
                  <div class="col-6">
                    <a
                      href="javascript:void(0);"
                      class="btn btn-primary continue-btn"
                      @click.prevent="deleteSub"
                      data-dismiss="modal"
                      >Delete</a
                    >
                  </div>
                  <div class="col-6">
                    <a
                      href="javascript:void(0);"
                      data-dismiss="modal"
                      class="btn btn-primary cancel-btn"
                      >Cancel</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-dialog>
        <!-- /Delete Designation Modal -->
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>
<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import { required } from "vuelidate/lib/validators";
import { authenticationService } from "@/services/authenticationService";
import { paymentService } from "@/services/paymentService";
export default {
  components: {
    LayoutHeader,
    LayoutSidebar
  },
  data() {
    return {
      dialog: false,
      dialogEdit: false,
      dialogDelete: false,
      headers: [
        { text: "Name", value: "name" },
        { text: "Category", value: "salaryCategory.name" },
        { text: "", value: "actions", sortable: false }
      ],
      name: "",
      subs: [],
      sub: {},
      company: authenticationService.currentOfficeValue,
      categories: [],
      category: null,
      submitted: false,
      loading: false,
      error: "",
      message: ""
    };
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    dialogEdit(val) {
      val || this.closeEdit();
    }
  },
  methods: {
    openDialog() {
      this.dialog = true;
    },
    clearModel() {
      this.name = "";
      this.category = "";
      thissubmitted = false;
    },
    close() {
      this.dialog = false;
      this.clearModel();
    },
    closeEdit() {
      this.dialogEdit = false;
    },
    closeDelete() {
      this.dialogDelete = false;
    },
    setEdit(model) {
      this.sub = model;
      this.dialogEdit = true;
      console.log(model);
    },
    setDelete(model) {
      this.sub = model;
      this.dialogDelete = true;
    },
    getSubs() {
      paymentService.getSalarySubCategories(this.company.id).then(
        model => {
          this.subs = model;
          // console.log(model);
        },
        error => {
          error = error;
        }
      );
    },
    getCategories() {
      paymentService.getSalaryCategories().then(
        model => {
          this.categories = model;
          // console.log(model);
        },
        error => {
          error = error;
        }
      );
    },
    setSub(item) {
      this.sub = item;
    },
    updateSub() {
      this.submitted = true;

      this.loading = true;
      //console.log('department updated 1')

      this.sub.categoryId = this.category;
      this.sub.salaryCategory.name = this.name;

      paymentService.updateSalarySubCategory(this.sub).then(
        id => {
          paymentService.getSalarySubCategories(this.company.id).then(o => {
            this.subs = o;
            this.closeEdit();
          });
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    },
    deleteSub() {
      const id = this.sub.id;
      paymentService.removeSalarySubCategory(id).then(
        id => {
          paymentService.getSalarySubCategories(this.company.id).then(o => {
            this.subs = o;
            this.dialogDelete = false;
          });
        },
        e => {
          this.error = "Sub Category being used in some information";
          this.dialogDelete = false;
        }
      );
    },
    onSubmit() {
      this.submitted = true;

      // stop here if form is invalid
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      this.loading = true;
      var req = {
        companyId: this.company.id,
        name: this.name,
        categoryId: this.category
      };
      paymentService.addSalarySubCategory(req).then(
        id => {
          //console.log(this.name, this.department)
          paymentService.getSalarySubCategories(this.company.id).then(o => {
            this.subs = o;
            this.close();
          });
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    }
  },
  validations: {
    name: { required },
    category: { required }
  },
  mounted() {
    this.getSubs();
    this.getCategories();

    // Select 2
    if ($(".select").length > 0) {
      $(".select").select2({
        minimumResultsForSearch: -1,
        width: "100%"
      });
    }
    // Multiselect
    if ($("#customleave_select").length > 0) {
      $("#customleave_select").multiselect();
    }
    if ($("#edit_customleave_select").length > 0) {
      $("#edit_customleave_select").multiselect();
    }
    // Datatable

    // if ($('.datatable').length > 0) {
    //   $('.datatable').DataTable({
    //     "bFilter": false,
    //   });
    // }
    // if ($('.floating').length > 0) {
    //   $('.floating').on('focus blur', function (e) {
    //     $(this).parents('.form-focus').toggleClass('focused', (e.type === 'focus' || this.value.length > 0));
    //   }).trigger('blur');
    // }
  },
  name: "designations"
};
</script>



// WEBPACK FOOTER //
// src/components/payroll/subcategories.vue